import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import apiClient from "../API"; // 👈 import your axios instance
import { buttonloginstyle, formatAuthError } from "../help/Utils";
import resetIcon from "../assets/reset.png";
import secure from "../assets/secure.png";
import "aos/dist/aos.css";

const ResetPassword = () => {
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setSuccess("");

    if (!email.trim()) {
      setError("Please enter your email");
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email.trim())) {
      setError("Please enter a valid email address.");
      return;
    }

    try {
      setLoading(true);
      console.log("Submitting reset request...");

      const res = await apiClient.post("/auth/forgot-password", {
        email: email.trim(),
      });

      console.log("Reset link sent:", res.data);
      setSuccess("Reset link sent! Please check your email.");
      localStorage.setItem("resetEmail", email.trim());

      setError("");

      setTimeout(() => {
        navigate("/reset-password-link");
      }, 3000);
    } catch (err) {
      console.error("API error:", err);

      let errorMessage = "Something went wrong. Please try again.";

      if (err.response) {
        // Backend error
        if (err.response.status === 404) {
          errorMessage =
            "No account found with this email. Please check and try again.";
        } else if (err.response.data?.message) {
          errorMessage = err.response.data.message;
        }
      } else if (err.message) {
        // Network / unknown error
        errorMessage = err.message;
      }

      setError(formatAuthError(errorMessage, "forgot-password"));
      setSuccess("");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="relative login_main body_padding pb-[100px] ">
      <div className="text-center">
        <img src={resetIcon} alt="reset icon" className="mx-auto mb-3" />
      </div>
      <h1 className="mb-2 text-center">Reset your password</h1>
      <p className="text-center mb-10 text-[18px]">
        Enter your email or phone number and we'll send <br /> you a reset link
      </p>

      <form
        onSubmit={handleSubmit}
        className="bg-white rounded-xl border border-gray-200 shadow-sm sm:p-[35px] p-5 rounded-2xl w-full max-w-[90%] sm:max-w-[500px] mx-auto login_form"
      >
        <div className="">
          <label className="mt-2 flex text-sm font-semibold">Email </label>
          <input
            type="text"
            name="adminUsername"
            placeholder="Enter your email "
            className={`border border-gray-200 rounded-lg w-full py-[14px] px-[16px] text-base`}
            aria-describedby="adminUsername-error"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>
        {error && <p className="text-red-500 text-sm mt-2">{error}</p>}
        {success && <p className="text-green-600 text-sm mt-2">{success}</p>}
        <button
          type="submit"
          style={buttonloginstyle}
          disabled={loading}
          className={`w-full mt-5 mb-5`}
        >
          {loading ? "Sending..." : "Send Reset Link"}
        </button>
        <div className=" pt-5 border-t border-gray-200 ">
          <p className="text-center font-semibold">
            Remember your password?{" "}
            <Link to="/" className="text-[#E76F51] font-bold">
              Login
            </Link>
          </p>
        </div>
      </form>
      <div className="mt-6 flex justify-center items-center ">
        {" "}
        <img src={secure} alt="secure login" className="me-3" />
        Secure reset process protected by encryption
      </div>
    </div>
  );
};

export default ResetPassword;
